import { NavigationItem } from './types';

interface Constants {
  languages: NavigationItem[];
  domains: {
    wix: string;
    wixNaked: string;
    wixUsers: string;
  };
  fixedDomains: string[];
}

export const constants: Constants = {
  languages: [
    {
      text: 'English',
      href: 'https://www.wix.com/',
      name: 'en',
    },
    {
      text: 'Deutsch',
      href: 'https://de.wix.com/',
      name: 'de',
    },
    {
      text: 'Español',
      href: 'https://es.wix.com/',
      name: 'es',
    },
    {
      text: 'Français',
      href: 'https://fr.wix.com/',
      name: 'fr',
    },
    {
      text: 'Italiano',
      href: 'https://it.wix.com/',
      name: 'it',
    },
    {
      text: 'Nederlands',
      href: 'https://nl.wix.com/',
      name: 'nl',
    },
    {
      text: 'Norsk',
      href: 'https://no.wix.com/',
      name: 'no',
    },
    {
      text: 'Polski',
      href: 'https://pl.wix.com/',
      name: 'pl',
    },
    {
      text: 'Português',
      href: 'https://pt.wix.com/',
      name: 'pt',
    },
    {
      text: 'Русский',
      href: 'https://ru.wix.com/',
      name: 'ru',
    },
    {
      text: 'Svenska',
      href: 'https://sv.wix.com/',
      name: 'sv',
    },
    {
      text: '日本語',
      href: 'https://ja.wix.com/',
      name: 'ja',
    },
    {
      text: '한국어',
      href: 'https://ko.wix.com/',
      name: 'ko',
    },
    {
      text: 'Türkçe',
      href: 'https://tr.wix.com/',
      name: 'tr',
    },
    {
      text: 'Dansk',
      href: 'https://da.wix.com/',
      name: 'da',
    },
    {
      text: 'हिन्दी',
      href: 'https://hi.wix.com/',
      name: 'hi',
    },
    {
      text: 'Čeština',
      href: 'https://cs.wix.com/',
      name: 'cs',
    },
    {
      text: 'ไทย',
      href: 'https://th.wix.com/',
      name: 'th',
    },
    {
      text: 'Українська',
      href: 'https://uk.wix.com/',
      name: 'uk',
    },
    {
      text: '繁體中文',
      href: 'https://zh.wix.com/',
      name: 'zh',
    },
  ],
  domains: {
    wix: 'www.wix.com',
    wixNaked: 'wix.com',
    wixUsers: 'users.wix.com',
  },
  fixedDomains: ['premium.wix.com'],
};
